import React, { useState, useEffect } from "react";
import { db } from "./firebase";
import {
  collection,
  addDoc,
  getDocs,
  serverTimestamp,
  onSnapshot,
  orderBy,
  query,
} from "firebase/firestore";

const AddPartner = () => {
  const [partnerName, setPartnerName] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [uploading, setUploading] = useState(false);
  const [partners, setPartners] = useState([]);

  // ✅ تحميل الشركاء من Firestore
  useEffect(() => {
    const q = query(collection(db, "partners"), orderBy("createdAt", "desc"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setPartners(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    });
    return unsubscribe;
  }, []);

  // ✅ رفع الصورة إلى Cloudinary
  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "iisdweb");

    try {
      const res = await fetch("https://api.cloudinary.com/v1_1/dys8jv8c2/upload", {
        method: "POST",
        body: formData,
      });
      const data = await res.json();
      setImageUrl(data.secure_url);
    } catch (error) {
      console.error("Upload error:", error);
    } finally {
      setUploading(false);
    }
  };

  // ✅ حفظ البيانات في Firestore
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!partnerName || !imageUrl) return alert("برجاء إدخال كل البيانات");

    try {
      await addDoc(collection(db, "partners"), {
        name: partnerName,
        image: imageUrl,
        createdAt: serverTimestamp(),
      });
      setPartnerName("");
      setImageUrl("");
      alert("تمت إضافة الشريك بنجاح ✅");
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>إضافة شريك جديد 🤝</h2>
      <form onSubmit={handleSubmit} style={styles.form}>
        <input
          type="text"
          placeholder="اسم الشريك"
          value={partnerName}
          onChange={(e) => setPartnerName(e.target.value)}
          style={styles.input}
        />

        <input type="file" onChange={handleImageUpload} style={styles.fileInput} />
        {uploading && <p>جاري رفع الصورة...</p>}
        {imageUrl && <img src={imageUrl} alt="preview" style={styles.preview} />}

        <button type="submit" style={styles.button}>
          إضافة
        </button>
      </form>

      {/* ✅ جدول عرض الشركاء */}
      <h3 style={{ marginTop: "40px", color: "#0056b3" }}>قائمة الشركاء الحالية</h3>
      <table style={styles.table}>
        <thead>
          <tr>
            <th>الاسم</th>
            <th>الصورة</th>
            <th>تاريخ الإضافة</th>
          </tr>
        </thead>
        <tbody>
          {partners.map((partner) => (
            <tr key={partner.id}>
              <td>{partner.name}</td>
              <td>
                <img
                  src={partner.image}
                  alt={partner.name}
                  style={{ width: "80px", borderRadius: "8px" }}
                />
              </td>
              <td>
                {partner.createdAt
                  ? new Date(partner.createdAt.seconds * 1000).toLocaleString("ar-EG")
                  : "—"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "700px",
    margin: "40px auto",
    background: "#fff",
    padding: "30px",
    borderRadius: "10px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    textAlign: "center",
  },
  title: {
    marginBottom: "20px",
    color: "#0056b3",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  input: {
    padding: "10px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    fontSize: "16px",
  },
  fileInput: {
    fontSize: "15px",
  },
  preview: {
    width: "120px",
    height: "120px",
    objectFit: "contain",
    margin: "10px auto",
    border: "1px solid #eee",
    borderRadius: "8px",
  },
  button: {
    backgroundColor: "#0056b3",
    color: "#fff",
    border: "none",
    padding: "12px",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "16px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "20px",
  },
  th: {
    borderBottom: "2px solid #ddd",
    padding: "10px",
    background: "#f5f5f5",
  },
  td: {
    borderBottom: "1px solid #eee",
    padding: "10px",
  },
};

export default AddPartner;
